import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { Session } from 'services';
import httpClient from 'utils/httpClient';

const CHECK_OUT = (id: Number) => `/v2/teacher/unit/${id}/checkout`;

export type checkOutBody = {
  id: number;
};

export type ConfirmSessionResponse = {
  session: Session;
};

export const checkOut = ({ id }: checkOutBody) => {
  let params = {};

  return httpClient.post<ConfirmSessionResponse>(CHECK_OUT(id), params);
};

export const useCheckOut = (
  opts?: UseMutationOptions<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    checkOutBody
  >,
) =>
  useMutation<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    checkOutBody
  >(checkOut, opts);
